import React from "react";
import { formatTime } from "../../../Functionalities/Functions";

function ProductSlotsSection({
  data,
  setData,
  sloats,
  setSloats,
  handleSloatRemove,
  handleSloatUpdate,
}) {
  const onChange = (e) => {
    if (e.target.value !== "") {
      const selectedSloat = sloats.find((item) => item.id == e.target.value);
      setData({
        ...data,
        sloats: [...data.sloats, selectedSloat],
        sloatId: "",
      });
      setSloats(sloats.filter((item) => item.id !== selectedSloat.id));
    }
  };

  return (
    <div className="form-group row">
      <label className="col-sm-12 col-form-label">
        Slots :{" "}
      </label>
      <div className="col-sm-8">
        <select
          name="categoryid"
          value={data.sloatId || ""}
          onChange={onChange}
          className="form-control"
          data-placeholder="Choose Slots"
          tabIndex={-1}
          aria-hidden="true"
        >
          <option value={""}>
            {"------Select slots------"}
          </option>
          {sloats.map((item, index) => (
            <option key={index} value={item.id}>
              {item.name} - {item.from_time} to {item.to_time}
            </option>
          ))}
        </select>
        <div
          style={{
            marginTop: 5,
            color: "white",
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          {data.sloats.length > 0 && (
            <h5 className="w-100 text-dark mt-2 mb-2">Selected slots</h5>
          )}

          {data.sloats.map((item) => (
            <div
              key={item.id}
              style={{
                marginBottom: 5,
                paddingLeft: 10,
                paddingRight: 10,
                width: "100%",
                maxWidth: 500,
                height: 35,
                backgroundColor: "#3fb049",
                marginRight: 5,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderRadius: 4,
              }}
            >
              <p className="m-0 text-white">
                {item.name} - {formatTime(item.from_time)} to {formatTime(item.to_time)}
              </p>

              <span
                style={{
                  fontSize: 18,
                  cursor: "pointer",
                  color: "white",
                  fontWeight: "bold",
                }}
                onClick={() => handleSloatRemove(item.id)}
              >
                ×
              </span>
            </div>
          ))}
        </div>
      </div>
      <div className="col-sm-3">
        <button
          className="submit btn btn-primary"
          name="submit"
          onClick={(e) => {
            e.preventDefault();
            handleSloatUpdate();
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
}

export default ProductSlotsSection;
